import * as React from 'react';
import { useTooltipController } from './useTooltipController';
import { CustomTooltip } from '../CustomTooltip';

/**
 * Компонент подсказки в виде всплывающего текста
 *
 * @export
 * @param {ITooltipProps} props
 * @returns
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TooltipDesktop(props) {
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'black' : _props$theme,
    placement = props.placement,
    title = props.title,
    portal = props.portal,
    arrow = props.arrow;
  var _useTooltipController = useTooltipController(props),
    childrenProps = _useTooltipController.childrenProps,
    tooltipProps = _useTooltipController.tooltipProps;
  var open = tooltipProps.open,
    anchorRef = tooltipProps.anchorRef,
    onMouseEnter = tooltipProps.onMouseEnter,
    onMouseLeave = tooltipProps.onMouseLeave;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(props.children, childrenProps), /*#__PURE__*/_jsx(CustomTooltip, {
      open: open,
      anchorRef: anchorRef,
      content: title,
      placement: placement,
      theme: theme,
      portal: portal,
      arrow: arrow,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}